import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@portal/environments/environment';
import { SelectionService } from '@portal/app/shared/services/selection.service';
import { AuthService } from '@portal/app/shared/services/auth.service';

export enum FeatureName {
  mimExportBanner = 'MIM_EXPORT_BANNER'
}

export enum FeatureFlagVisibility {
  allUsers = 'ALL_USERS',
  internalUsers = 'INTERNAL_USERS'
}

export type IFeatureConfigResponse = {
  [featureName in FeatureName]: FeatureFlagVisibility;
};

@Injectable({
  providedIn: 'root'
})
export class FeatureConfigService {
  measuredUriV1 = `${environment.apiDomain}/api/v1/`;

  private dataSubject = new BehaviorSubject<IFeatureConfigResponse>(
    {} as IFeatureConfigResponse
  );

  data$ = this.dataSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly selectionService: SelectionService,
    private readonly authService: AuthService
  ) {
    this.fetchData();
  }

  fetchData() {
    const { clientId, brandId } = this.selectionService.getClientIdAndBrandId();
    return this.http
      .get<IFeatureConfigResponse>(
        `${this.measuredUriV1}feature-config?clientId=${clientId}&brandId=${brandId}`
      )
      .subscribe((data) => {
        this.setData(data);
      });
  }

  setData(data: IFeatureConfigResponse): void {
    this.dataSubject.next(data);
  }

  getData(): IFeatureConfigResponse {
    return this.dataSubject.getValue();
  }

  isFeatureEnabled(key: FeatureName): boolean {
    const isMeasuredUser = this.authService.getUser()?.isMeasuredUser();
    const visibility = isMeasuredUser
      ? [FeatureFlagVisibility.internalUsers, FeatureFlagVisibility.allUsers]
      : [FeatureFlagVisibility.allUsers];

    const config = this.dataSubject.getValue();
    const value = config[key];
    return !!(value && visibility.includes(value));
  }
}
